<template>
  <div class="archs">
    <Table
      border
      stripe
      :columns="columns"
      :data="data"
      :loading="loading"
      highlight-row
      @on-row-click="clickRow"
    />
    <Page
      v-if="total > pageSize"
      :total="total"
      show-sizer
      show-elevator
      :page-size="pageSize"
      :current="current"
      @on-change="handleChange"
      @on-page-size-change="handlePageSizeChange"
      class-name="page"
    />
  </div>
</template>

<script>
import { GetArchs } from '@api'
export default {
  name: 'search-archsTable',
  data () {
    return {
      columns: [],
      loading: false,
      total: 0,
      pageSize: 10,
      current: 1,
      item: {},
      data: []
    }
  },
  mounted () {
    this.buildColumns()
  },
  methods: {
    async init (row = {}) {
      this.item = row
      this.data = []
      this.total = 0
      this.current = 1
      if (!row.SID) return
      await this.getPage()
      const { offsetTop } = this.$el
      window.scroll(0, offsetTop + 280)
    },
    buildColumns () {
      const columns = [
        {
          title: '案卷题名',
          render: (h, params) => {
            const { ARCH_TITLE } = params.row
            return (
              <span
                class="nameLink"
              >{ ARCH_TITLE }</span>
            )
          }
        }, {
          title: '总登记号',
          width: 150,
          align: 'center',
          key: 'REG_NO'
        }
      ]
      this.$set(this, 'columns', columns)
    },
    async getPage () {
      this.$emit('on-init-table')
      this.loading = true
      try { 
        const query = Object.assign({
          PageIndex: this.current,
          PageSize: this.pageSize
        }, { SID: this.item.SID })
        const { data: { list, total } } = await GetArchs(query)
        this.data = list || []
        this.total = total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleChange (index) {
      this.current = index
      this.getPage()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.getPage()
    },
    clickRow (row, index) {
      this.$emit('on-click-row', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  margin-top: 16px;
  text-align: right;
}
.archs {
  margin-top: 16px;
}
</style>